import { PAYMENT_AUTHORIZATION_ERROR } from "./payments";
export var CHECKOUT_STATUS = /* @__PURE__ */ ((CHECKOUT_STATUS2) => {
  CHECKOUT_STATUS2["CREATED"] = "created";
  CHECKOUT_STATUS2["CANCELED"] = "canceled";
  CHECKOUT_STATUS2["PENDING"] = "pending";
  CHECKOUT_STATUS2["REDIRECTED"] = "redirected";
  CHECKOUT_STATUS2["COMPLETING"] = "completing";
  CHECKOUT_STATUS2["COMPLETE"] = "complete";
  CHECKOUT_STATUS2["PREORDER"] = "preorder";
  CHECKOUT_STATUS2["SCHEDULED"] = "scheduled";
  CHECKOUT_STATUS2["ERROR"] = "error";
  return CHECKOUT_STATUS2;
})(CHECKOUT_STATUS || {});
export var CHECKOUT_ERROR = /* @__PURE__ */ ((CHECKOUT_ERROR2) => {
  CHECKOUT_ERROR2["UNKNOWN_ERROR"] = "unknown_error";
  CHECKOUT_ERROR2["AUTHORIZATION_UNKNOWN_ERROR"] = "authorization_unknown_error";
  CHECKOUT_ERROR2["AUTHORIZATION_CVV_CODE_INCORRECT"] = "authorization_cvv_code_incorrect";
  CHECKOUT_ERROR2["AUTHORIZATION_POST_CODE_INCORRECT"] = "authorization_post_code_incorrect";
  CHECKOUT_ERROR2["AUTHORIZATION_INSUFFICIENT_FUNDS"] = "authorization_insufficient_funds";
  CHECKOUT_ERROR2["AUTHORIZATION_CARD_NUMBER_INCORRECT"] = "authorization_card_number_incorrect";
  CHECKOUT_ERROR2["AUTHORIZATION_CARD_EXPIRED"] = "authorization_card_expired";
  CHECKOUT_ERROR2["ZERO_AMOUNT"] = "zero_amount";
  CHECKOUT_ERROR2["SHIPPING_OPTIONS_NOT_FOUND"] = "shipping_options_not_found";
  return CHECKOUT_ERROR2;
})(CHECKOUT_ERROR || {});
export const PAYMENT_AUTHORIZATION_ERROR_TO_CHECKOUT_ERROR = {
  [PAYMENT_AUTHORIZATION_ERROR.DUPLICATE]: "authorization_unknown_error" /* AUTHORIZATION_UNKNOWN_ERROR */,
  [PAYMENT_AUTHORIZATION_ERROR.CVV_CODE_INCORRECT]: "authorization_cvv_code_incorrect" /* AUTHORIZATION_CVV_CODE_INCORRECT */,
  [PAYMENT_AUTHORIZATION_ERROR.BILLING_ADDRESS_INCORRECT]: "authorization_post_code_incorrect" /* AUTHORIZATION_POST_CODE_INCORRECT */,
  [PAYMENT_AUTHORIZATION_ERROR.BILLING_POST_CODE_INCORRECT]: "authorization_post_code_incorrect" /* AUTHORIZATION_POST_CODE_INCORRECT */,
  [PAYMENT_AUTHORIZATION_ERROR.INSUFFICIENT_FUNDS]: "authorization_insufficient_funds" /* AUTHORIZATION_INSUFFICIENT_FUNDS */,
  [PAYMENT_AUTHORIZATION_ERROR.CARD_NUMBER_INCORRECT]: "authorization_card_number_incorrect" /* AUTHORIZATION_CARD_NUMBER_INCORRECT */,
  [PAYMENT_AUTHORIZATION_ERROR.CARD_EXPIRED]: "authorization_card_expired" /* AUTHORIZATION_CARD_EXPIRED */,
  [PAYMENT_AUTHORIZATION_ERROR.TRANSACTION_NOT_ALLOWED]: "authorization_unknown_error" /* AUTHORIZATION_UNKNOWN_ERROR */,
  [PAYMENT_AUTHORIZATION_ERROR.REQUIRES_ACTION]: "authorization_unknown_error" /* AUTHORIZATION_UNKNOWN_ERROR */,
  [PAYMENT_AUTHORIZATION_ERROR.ZERO_AMOUNT]: "zero_amount" /* ZERO_AMOUNT */,
  [PAYMENT_AUTHORIZATION_ERROR.INSTRUMENT_NOT_FOUND]: "authorization_unknown_error" /* AUTHORIZATION_UNKNOWN_ERROR */
};
export var FINALIZE_CHECKOUT_STATUS = /* @__PURE__ */ ((FINALIZE_CHECKOUT_STATUS2) => {
  FINALIZE_CHECKOUT_STATUS2["COMPLETE"] = "complete";
  FINALIZE_CHECKOUT_STATUS2["COMPLETE_REDIRECT"] = "complete_redirect";
  FINALIZE_CHECKOUT_STATUS2["REDIRECT_TO_CONTINUE"] = "redirect_to_continue";
  FINALIZE_CHECKOUT_STATUS2["RECENT_ORDER_CONFIRM"] = "recent_order_confirm";
  FINALIZE_CHECKOUT_STATUS2["AMOUNT_MISMATCH_CONFIRM"] = "amount_mismatch_confirm";
  FINALIZE_CHECKOUT_STATUS2["NO_STOCK_PREORDER_INITIATED"] = "no_stock_preorder_initiated";
  FINALIZE_CHECKOUT_STATUS2["NO_STOCK_PARTIAL_ORDER_INITIATED"] = "no_stock_partial_order_initiated";
  FINALIZE_CHECKOUT_STATUS2["NO_STOCK_FAILED"] = "no_stock_failed";
  FINALIZE_CHECKOUT_STATUS2["NO_EMAIL_FAILED"] = "no_email_failed";
  FINALIZE_CHECKOUT_STATUS2["SCHEDULED"] = "scheduled";
  return FINALIZE_CHECKOUT_STATUS2;
})(FINALIZE_CHECKOUT_STATUS || {});
export var ORDER_TAGS = /* @__PURE__ */ ((ORDER_TAGS2) => {
  ORDER_TAGS2["ONETEXT"] = "Text Order";
  ORDER_TAGS2["ONETEXT_REFILL"] = "Text Refill";
  ORDER_TAGS2["ONETEXT_REFILL_FIRST_ORDER"] = "Text Refill 1st Order";
  ORDER_TAGS2["ONETEXT_REFILL_REPEAT_ORDER"] = "Text Refill Repeat Order";
  ORDER_TAGS2["ONETEXT_FAILED_REFUND"] = "Failed Refund";
  return ORDER_TAGS2;
})(ORDER_TAGS || {});
